import * as React from "react";

const ButtonCart: React.FC = () => {
    return (
        <svg
            width="18px"
            height="16px"
            viewBox="0 0 18 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M0.5,0 L0,0 L0,1 L0.5,1 L2.0999999,1 L4.51249981,11.609375 L4.5999999,12 L5,12 L15.5,12 L16,12 L16,11 L15.5,11 L5.39999962,11 L4.94687462,9 L15.5,9 L17.6875,2 L18,1 L16.953125,1 L3.125,1 L2.98749971,0.390625 L2.89999962,0 L2.5,0 L0.5,0 L0.5,0 Z M3.35312462,2 L16.640625,2 L14.765625,8 L4.71875,8 L3.35312462,2 L3.35312462,2 Z M5.75,13.5 C6.16421366,13.5 6.5,13.8357868 6.5,14.25 C6.5,14.6642132 6.16421366,15 5.75,15 C5.33578634,15 5,14.6642132 5,14.25 C5,13.8357868 5.33578634,13.5 5.75,13.5 Z M5.75,16 C6.37521458,16 6.95293713,15.6664515 7.26554441,15.125 C7.5781517,14.5835485 7.5781517,13.9164515 7.26554441,13.375 C6.95293713,12.8335485 6.37521458,12.5 5.75,12.5 C5.12478542,12.5 4.54706287,12.8335485 4.23445559,13.375 C3.92184782,13.9164515 3.92184782,14.5835485 4.23445559,15.125 C4.54706287,15.6664515 5.12478542,16 5.75,16 Z M13.5,14.25 C13.5,13.8357868 13.8357868,13.5 14.25,13.5 C14.6642132,13.5 15,13.8357868 15,14.25 C15,14.6642132 14.6642132,15 14.25,15 C13.8357868,15 13.5,14.6642132 13.5,14.25 Z M16,14.25 C16,13.6247854 15.6664515,13.0470629 15.125,12.7344551 C14.5835485,12.4218483 13.9164515,12.4218483 13.375,12.7344551 C12.8335485,13.0470629 12.5,13.6247854 12.5,14.25 C12.5,14.8752146 12.8335485,15.4529371 13.375,15.7655449 C13.9164515,16.0781517 14.5835485,16.0781517 15.125,15.7655449 C15.6664515,15.4529371 16,14.8752146 16,14.25 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ButtonCart);
